import { render, staticRenderFns } from "./voa-report.vue?vue&type=template&id=27d99606"
import script from "./voa-report.vue?vue&type=script&lang=js"
export * from "./voa-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports